import React from "react";

const Copyright = () => {
  return (
    <div className="copyright">
      <p>© {new Date().getFullYear()} Wedding City Australia</p>
    </div>
  );
};

export default Copyright;
